import { createContext } from 'react';
import { AppConfigType } from '../client-server-utils/appConfig';

const AppConfigContext = createContext<AppConfigType | null>(null);
AppConfigContext.displayName = 'AppConfigContext';

export default AppConfigContext;
